import { AfterViewInit, Component, ElementRef, Inject, ViewChild } from '@angular/core'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { take } from 'rxjs/operators'

type CallBackFunction = () => void

export interface GenericDialogData {
  cancelText: string
  acceptText: string

  title: string
  message?: string

  onClose?: CallBackFunction
  onCancel?: CallBackFunction
  onAccept?: CallBackFunction

  /** When true, focus the accept button after open (e.g., destructive confirms). */
  focusAccept?: boolean
}

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss']
})
export class DialogComponent implements AfterViewInit {

  @ViewChild('acceptButton', { read: ElementRef }) acceptButton: ElementRef<HTMLButtonElement>

  onClose: CallBackFunction
  onCancel: CallBackFunction
  onAccept: CallBackFunction
  cancelText: string
  acceptText: string
  title: string
  confirmMessage: string
  focusAccept: boolean = false

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: GenericDialogData,
    public dialogRef: MatDialogRef<DialogComponent>) {
    if (data) {
      const voidFunction = () => { }
      this.onClose = data.onClose || voidFunction
      this.onCancel = data.onCancel || voidFunction
      this.onAccept = data.onAccept || voidFunction
      this.cancelText = data.cancelText
      this.acceptText = data.acceptText
      this.title = data.title
      this.confirmMessage = data.message
      this.focusAccept = !!data.focusAccept
      const closed$ = (this.dialogRef as any)?.afterClosed?.()
      if (closed$) {
        closed$.pipe(take(1)).subscribe(() => {
          this.onClose()
        })
      }

    }

  }

  ngAfterViewInit(): void {
    if (!this.focusAccept) {
      return
    }

    const opened$ = (this.dialogRef as any)?.afterOpened?.()
    if (!opened$) {
      return
    }

    opened$.pipe(take(1)).subscribe(() => {
      setTimeout(() => {
        this.acceptButton?.nativeElement?.focus()
      }, 0)
    })
  }

  handleCancel() {
    this.onCancel()
  }

  handleAccept() {
    this.onAccept()
  }
}
